const authRoutes = [
  {
    path: '/',
    name: 'validador',
    component: () => lazyLoadView(import('@views/pages/validador/validador')),
  }
]


const allRoutes = [...authRoutes]

export { allRoutes }

function lazyLoadView(AsyncView) {
  const AsyncHandler = () => ({
    component: AsyncView,
    delay: 400,
    timeout: 10000,
  })

  return Promise.resolve({
    functional: true,
    render(h, { data, children }) {
      return h(AsyncHandler, data, children)
    },
  })
}
